import React from "react";
import { Navigation } from "./navigation";

export const NavigationContext = React.createContext<{
  navigation: Navigation;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}>({ navigation: [], isExpanded: false, setIsExpanded: () => {} });

export const useNavigation = () => React.useContext(NavigationContext);
